module.exports = __webpack_public_path__ + "static/img/icon-upload-cash-result.ee797214.png";